<template>
  <div style="width: 100%;height: 100%">

    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ titleData[0].ADDRESS }}</li>
          <li><span>送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ titleData[0].TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ titleData[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ titleData[0].TELPHONE }}</li>
          <li><span>订单编号</span>：{{ titleData[0].ORDER_CODE }}</li>
          <li><span>订单备注</span>：{{ titleData[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column label="调整价（元）">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ADJUST_REAL_PRICE" @change="adjustPriceChange(scope.row)" v-if="scope.row.edited">
              </el-input>
              <span v-else>{{ scope.row.ADJUST_REAL_PRICE }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="ADJUST_TOTAL_FEE" label="调整金额（元）">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ADJUST_TOTAL_FEE" v-if="scope.row.edited" disabled>
              </el-input>
              <span v-else>{{ scope.row.ADJUST_TOTAL_FEE }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100" v-if="canAdjust">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="() => { scope.row.edited = true }" :disabled="scope.row.edited">
                修改调整价
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <tooltip-button v-if="canAdjust" :disabled="canResubmit" tipContent="请在修改调整价后重新提交" buttonText="重新提交" buttonSize="small"
        @click="submitPriceAdjustment" style="float: right; margin-top: 10px;">
      </tooltip-button>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['priceAdjustmentRecordsList'],
      toName: [],
      managername: sessionStorage.getItem('name'),
      titleData: [{}],
      tableData: [],
      companyID: Number(sessionStorage.getItem('tcId')),
      orderID: Number(sessionStorage.getItem('orderId')),
      adjustStatus: sessionStorage.getItem('adjustStatus'),
    };
  },
  computed: {
    canAdjust() {
      return ['1', '3'].includes(this.adjustStatus);
    },
    canResubmit() {
      return Boolean(this.tableData.find((item) => item.edited));
    },
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '10260',
        OTYPE: 4,
        SUPPLIER_ID: this.companyID,
        ORDER_ID: this.orderID,
      };
      http.post(params).then((res) => {
        this.titleData = res[0].TITLE;
        this.tableData = res[0].DETAIL.map((item) => ({
          ...item,
          edited: false,
        }));
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    adjustPriceChange(row) {
      if (!validation.价格正数0验证(row.ADJUST_REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        row.ADJUST_REAL_PRICE = '';
        return false;
      }
      row.ADJUST_REAL_PRICE = Number(row.ADJUST_REAL_PRICE).toFixed(2);
      row.ADJUST_TOTAL_FEE = (row.ADJUST_REAL_PRICE * row.PRODUCT_COUNT).toFixed(2);
    },
    submitPriceAdjustment() {
      const ORDER_DETAIL = [];
      for (const row of this.tableData.filter((item) => item.edited)) {
        if (!validation.价格正数0验证(row.ADJUST_REAL_PRICE)) {
          this.$message.show({ text: `${row.PRODUCT_NAME}输入的价格不正确，请重新输入`, type: 'warning' });
          return false;
        }
        ORDER_DETAIL.push({
          DETAIL_ID: row.DETAIL_ID,
          TYPE_UNIT: row.TYPE_UNIT,
          ADJUST_PRICE: row.ADJUST_REAL_PRICE,
          PRODUCT_CODE: row.PRODUCT_CODE,
        });
      }
      const params = {
        SERVICE_ID: '10260',
        OTYPE: 2,
        ORDER_ID: this.orderID,
        ORDER_DETAIL,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '重新提交成功', type: 'success' });
        this.adjustStatus = '1';
        this.queryData();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从订单调价申请记录进入调价详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryData();
      }
    });
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/priceAdjustmentDetail.vue